<template>
    <div>
        <div class="container">
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Plate Number</th>
                            <th>Unit Number</th>
                            <th>Make</th>
                            <th>Model</th>
                            <th>VIN</th>
                            <th>Available Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="dataPoint in returnData">
                            <td>{{dataPoint.PlateNo}}</td>
                            <td>{{dataPoint.UnitNumber}}</td>
                            <td>{{dataPoint.Make}}</td>
                            <td>{{dataPoint.Model}}</td>
                            <td>{{dataPoint.VIN}}</td>
                            <td>
                                <div class="table-button-container">
                                    <button class="btn btn-primary" @click="generatePDF(dataPoint.UUID)"><i class="fa fa-edit"></i>View Registration</button>
                                    <button class="btn btn-primary"  @click="printHere(dataPoint.UUID)"><i class="fa fa-edit"></i>Download Registration</button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div id="forPdf">

            </div>
        </div>
        <div id="pdfModal" class="modal" @click="closeModal" v-show="displayModal">
            <div class="modal-content">
                <span class="close glyphicon glyphicon-remove" @click="closeModal"></span>
                <div id="loading" v-show="displayLoading">
                    <h1>Loading</h1>
                    <span>.</span><span>.</span><span>.</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import swal from 'sweetalert2'
  import axios from 'axios'

  export default {
    name: 'results-page',
    data () {
      return {
        returnData: this.$store.getters.searchResults,
        displayLoading: true,
        displayModal: false
      }
    },
    methods: {
      generatePDF (UUID) {
        this.displayModal = true
        axios.post('./static/api/Ajax.php', {
          UUID,
          action: 'View Registration'
        }).then((response) => {
          console.log(response.data)
          if (response.data.status === 'success') {
            let iframeElement = document.createElement('iframe')
            let modalContent = document.getElementById('pdfModal')
              .getElementsByClassName('modal-content')[0]
            iframeElement.src = './static/api/201Form/201Form.php'
            iframeElement.type = 'application/pdf'
            iframeElement.classList.add('pdfIframeClass')
            modalContent.appendChild(iframeElement)
            document.getElementsByTagName('iframe')[0].onload = () => {
              this.displayLoading = false
            }
            this.displayLoading = true
          } else {
            swal(response.data.status)
          }
        }).catch((e) => {
          console.log(e)
        })
      },
      printHere (UUID) {
        axios.post('./static/api/Ajax.php', {
          UUID,
          action: 'View Registration'
        }).then((response) => {
          if (response.data.status === 'success') {
            let newWindow = window.open('./static/api/201Form/201Form.php?download=true')
            newWindow.focus()
          } else {
            swal(response.data.status)
          }
        }).catch((e) => {
          console.log(e)
        })
      },
      closeModal () {
        document.getElementById('pdfModal')
          .getElementsByClassName('modal-content')[0]
          .getElementsByTagName('iframe')[0].remove()
        this.displayModal = false
      }
    }
  }
</script>

<style scoped>
    .modal-content {
        top: 10%;
        width: 80%;
        left: 10%;
        max-width: 1000px;
        height: 80%;
    }
    .modal{
        display: block;
    }
    #loading{
        font-family:Lucida Grande, Helvetica, Verdana, sans-serif;
        background:rgba(0,0,0,1);
        color:#f2f2f2;
        overflow:hidden;
        top: 0;
        left: 0;
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 1000;
    }
    #loading h1{position:absolute;top:50%;left:50%;height:40px;line-height:40px;width:160px;margin:-20px 0 0 -80px;text-align:center;font-weight:normal;}
    #loading span{-webkit-animation:load 4s infinite ease-in-out;position:absolute;top:51%;height:10px;width:30px;text-align:right;font-size:200%;margin-left:-15px;}
    #loading span:nth-child(2){-webkit-animation-delay:.2s;width:20px;}
    #loading span:nth-child(3){-webkit-animation-delay:.4s;width:10px;}
    @-webkit-keyframes load{
        0%{left:-2%;}
        40%{left:50%;}
        60%{left:50%;}
        100%{left:102%;}
    }
</style>


// WEBPACK FOOTER //
// src/components/resultsPage.vue